import { useState, useEffect } from "preact/hooks";

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Set a timer to update the value after the delay
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    // If value or delay changes, clear the previous timer
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
